import React, { useEffect } from 'react'

import { createGlobalStyle } from 'styled-components'

import usePersistentState from './usePersistentState'

const SensitiveDataStyle = createGlobalStyle`
  [data-is-sensitive='true'], .data-is-sensitive {
    position: relative;
    color: transparent !important;
    * {
      color: transparent !important;
      opacity: 0 !important;
    }
    &:after{
      position: absolute;
      content: "";
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      background-color: var(--gray-100);
      border-radius: inherit;
    }
  }
`

export const useSensitiveDataToggle = () => {
  const [hideInfo, setHideInfo] = usePersistentState(false, 'isSensitiveInfoHidden')

  useEffect(() => {
    const handleKeyUp = (e: KeyboardEvent) => {
      if (e.ctrlKey && e.key === '.') {
        setHideInfo((hideInfo) => !hideInfo)
      }
    }
    document.addEventListener('keyup', handleKeyUp)
    return () => {
      document.removeEventListener('keyup', handleKeyUp)
    }
  }, [])

  return { globalSensitiveDataStyles: hideInfo ? <SensitiveDataStyle /> : null, hideInfo, setHideInfo }
}
